export default {
  computed: {
    isAssetGlobalAdmin() {
      const permissions = this.$store.getters.permissions || []
      const roles = this.$store.getters.roles || []
      return Boolean(this.$store.state.user.admin) || permissions.includes('*:*:*') || roles.includes('gly')
    },
    assetManagementScopeTypes() {
      if (this.isAssetGlobalAdmin) return ['HR', 'WAREHOUSE']
      const permissions = this.$store.getters.permissions || []
      const result = []
      if (permissions.includes('crm:asset:scope:hr')) result.push('HR')
      if (permissions.includes('crm:asset:scope:warehouse')) result.push('WAREHOUSE')
      return result
    },
    showAssetManagementSelector() {
      return this.isAssetGlobalAdmin
    },
    defaultAssetManagementType() {
      return this.assetManagementScopeTypes.length === 1 ? this.assetManagementScopeTypes[0] : ''
    }
  },
  methods: {
    applyAssetManagementDefault(model, key = 'managementType') {
      if (!this.showAssetManagementSelector && this.defaultAssetManagementType && !model[key]) {
        this.$set(model, key, this.defaultAssetManagementType)
      }
      return model
    }
  }
}
